(function(){
  var f=document.querySelector('[data-orb-form]');
  var g=document.querySelector('[data-orb-gallery]');
  var track=g&&g.querySelector('[data-orb-track]');
  var slides=track?track.children:[];
  var thumbs=g?g.querySelectorAll('.orb-thumb'):[];
  var dots=g?g.querySelectorAll('.orb-gallery__dots span'):[];
  var cur=0;
  function mark(i){cur=i;[].forEach.call(thumbs,function(t,k){t.classList.toggle('is-active',k===i)});[].forEach.call(dots,function(d,k){d.classList.toggle('is-active',k===i)});}
  function go(i){if(!track||!slides.length)return;i=(i+slides.length)%slides.length;track.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'});mark(i);}
  if(track){
    var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var i=Math.round(track.scrollLeft/track.clientWidth);if(i!==cur)mark(i);},60);},{passive:true});
    [].forEach.call(thumbs,function(b){b.addEventListener('click',function(){go(+b.dataset.index)})});
    var pv=g.querySelector('[data-orb-prev]'),nx=g.querySelector('[data-orb-next]');
    if(pv)pv.addEventListener('click',function(){go(cur-1)}); if(nx)nx.addEventListener('click',function(){go(cur+1)});
    var gv=track.querySelectorAll('video[data-src]');
    if(gv.length&&'IntersectionObserver' in window){
      var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){if(!v.getAttribute('src'))v.src=v.dataset.src;var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}else{v.pause();}});},{threshold:.6});
      [].forEach.call(gv,function(v){vio.observe(v);});
    }
  }
  if(f){
    var out=f.querySelector('[data-orb-atc-price]'),sp=document.querySelector('[data-orb-sticky-price]'),st=document.querySelector('[data-orb-sticky-title]');
    var sync=function(scroll){var r=f.querySelector('input[name="id"]:checked'); if(!r)return; if(out)out.textContent=r.dataset.price; if(sp)sp.textContent=r.dataset.price; if(st)st.textContent=r.dataset.title;
      if(scroll&&r.dataset.media&&track){for(var k=0;k<slides.length;k++){if(slides[k].dataset.mediaId===r.dataset.media){go(k);break;}}}};
    f.addEventListener('change',function(){sync(true)}); sync(false);
  }
  var wd=function(d,n,dir){var k=0;while(k<n){d.setDate(d.getDate()+dir);var w=d.getDay();if(w!==0&&w!==6)k++;}return d;};
  var loc=document.documentElement.lang||'en';
  var eta=document.querySelector('[data-orb-eta]'); if(eta){
    var fmt=function(d){return d.toLocaleDateString(loc,{weekday:'short',month:'short',day:'numeric'});};
    eta.innerHTML='<b>Order now</b>, get it between <b>'+fmt(wd(new Date(),+eta.dataset.min,1))+'</b> and <b>'+fmt(wd(new Date(),+eta.dataset.max,1))+'</b> · free tracked shipping';
  }
  var xm=document.querySelector('[data-orb-xmas]'); if(xm){
    var now=new Date(), lim=wd(new Date(now.getFullYear(),11,24),+xm.dataset.max,-1);
    if(now<lim){xm.textContent='🎁 Christmas gift? Order by '+lim.toLocaleDateString(loc,{month:'long',day:'numeric'})+' to get it in time.';xm.hidden=false;}
  }
  var tm=document.querySelector('[data-orb-timer]'); if(tm){
    var end=new Date(tm.dataset.end).getTime();
    if(!isNaN(end)&&end>Date.now()){
      tm.hidden=false; var q=function(s){return tm.querySelector(s)}; var pad=function(n){return(n<10?'0':'')+n};
      var iv; var tick=function(){var s=Math.max(0,Math.floor((end-Date.now())/1000)); if(s<=0){tm.hidden=true;clearInterval(iv);return;} q('[data-d]').textContent=Math.floor(s/86400); q('[data-h]').textContent=pad(Math.floor(s%86400/3600)); q('[data-m]').textContent=pad(Math.floor(s%3600/60)); q('[data-s]').textContent=pad(s%60);};
      tick(); iv=setInterval(tick,1000);
    }
  }
  var s=document.querySelector('[data-orb-sticky]'), btn=document.querySelector('[data-orb-atc]');
  if(s&&btn&&'IntersectionObserver' in window){ s.hidden=false;
    new IntersectionObserver(function(e){ s.classList.toggle('is-on', !e[0].isIntersecting); }).observe(btn);
  }
})();